<template>
  <div id="main-content" class="add-student">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row class="row-section">
        <input type="file" ref="file" @change="onChange" accept=".xlsx" />
        <el-button type="primary" @click="importFile" :disabled="!file">{{ $t('common.import') }}</el-button>
        <el-button type="success" @click="exportFile">{{ $t('import.export') }}</el-button>
        <el-button type="success" @click="exportQrFile">{{ $t('import.exportQr') }}</el-button>
      </el-row>
    </el-col>

    <el-dialog
        :title="$t('common.success')"
        :visible.sync="isShowPopup"
        width="50%">
      <div class="import-popup">
        <div class="success-section success-section--created">
          <h4>{{ $t('import.created_rows', { count: importData.created.length }) }}:</h4>
          <div>{{ importData.created.join(', ') }}</div>
        </div>
        <div class="success-section success-section--updated">
          <h4>{{ $t('import.updated_rows', { count: importData.updated.length }) }}:</h4>
          <div>{{ importData.updated.join(', ') }}</div>
        </div>
        <div class="failures-section">
          <h4>{{ $t('import.failure_rows', { count: importData.failures.length }) }}:</h4>
          <div class="failures-section__table" v-show="importData.failures.length">
            <table>
              <thead>
                <tr>
                  <th width="30%">{{ $t('import.row') }}</th>
                  <th width="70%">{{ $t('import.message') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(failure, index) in importData.failures" :key="index">
                  <td>{{ failure.row }}</td>
                  <td>
                    <div class="error-message" v-for="(message, messageIndex) in failure.messages" :key="messageIndex">
                      {{ message }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="agree">OK</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "StudentImport",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/student?action=back`,
        title: 'common.import',
        file: null,
        isShowPopup: false,
        importData: {
          created: [],
          updated: [],
          failures: []
        }
      }
    },
    methods: {
      importFile: function () {
        let data = new FormData()
        data.append('file', this.file)

        let payload = {
          data,
          successCallback: (response) => {
            this.$refs.file.value = ''
            this.file = null
            this.importData.created = response.data.data.created
            this.importData.updated = response.data.data.updated
            this.importData.failures = response.data.data.failures
            this.isShowPopup = true
          }
        }

        this.$store.dispatch('student/importStudents', payload)
      },
      exportFile: function () {
        let payload = {
          successCallback: (response) => {
            let link = document.createElement('a')
            link.href = response.data.data.url
            link.click()
            link.remove()
          }
        }

        this.$store.dispatch('student/exportStudents', payload)
      },
      exportQrFile: function () {
        let payload = {
          successCallback: (response) => {
            let link = document.createElement('a')
            link.href = response.data.data.url
            link.click()
            link.remove()
          }
        }

        this.$store.dispatch('student/exportQrStudents', payload)
      },
      onChange: function () {
        if (this.$refs.file.files.length) {
          this.file = this.$refs.file.files[0]
        } else {
          this.file = null
        }
      },
      agree: function () {
        this.isShowPopup = false
      }
    },
    mounted: function () {

    },
    computed: {

    }
  }
</script>

<style lang="scss">
  .import-popup {
    h4 {
      text-align: left;
    }

    .success-section {
      text-align: left;
      margin-bottom: 20px;
    }

    .failures-section {
      &__table {
        height: 300px;
        overflow-y: scroll;

        table {
          width: 100%;

          .error-message {
            text-align: left;
          }
        }
      }
    }
  }
</style>
